import {metadaApi} from '@dms/api/base';

import {isWarehouseAclScoped} from '../utils/isWarehouseAclScoped';
import {createWarehouseAclScopedSerializer} from '../utils/serializeWarehouseAclScopedArgs';
import {
  HeaderDynamicActionsEventRequest,
  HeaderDynamicActionsEventRequestSchema,
  HeaderDynamicActionsEventResponse,
  HeaderDynamicActionsEventResponseSchema,
  HeaderDynamicActionsRequest,
  HeaderDynamicActionsRequestSchema,
  HeaderDynamicActionsResponse,
  HeaderDynamicActionsResponseSchema,
} from './types';

// Only the article actions have a v2 that checks the warehouse ACL scopes
const isArticleActionsAclScoped = (queryArg: HeaderDynamicActionsRequest) =>
  queryArg.resource === 'article' && isWarehouseAclScoped(queryArg);

export const metadaWarehouseHeaderDynamicActionsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getWarehouseHeaderDynamicActions: build.query<
      HeaderDynamicActionsResponse,
      HeaderDynamicActionsRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/${isArticleActionsAclScoped(queryArg) ? 'v2' : (queryArg.version ?? 'v1')}/${queryArg.resource}/${queryArg.id}/actions`,
        method: 'GET',
      }),
      serializeQueryArgs: createWarehouseAclScopedSerializer(isArticleActionsAclScoped),
      providesTags: ['headerDynamicActions'],
      extraOptions: {
        requestSchema: HeaderDynamicActionsRequestSchema,
        responseSchema: HeaderDynamicActionsResponseSchema,
      },
    }),
    putWarehouseHeaderDynamicActions: build.mutation<
      HeaderDynamicActionsEventResponse,
      HeaderDynamicActionsEventRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/${queryArg.version ?? 'v1'}/${queryArg.resource}/${queryArg.id}/action`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: [
        'article',
        'deliveryNote',
        'receiveNoteState',
        'receiveNoteInfo',
        'receiveNoteCorrections',
        'directSales',
        'serviceOrderIssueNotes',
        'serviceOrderReturns',
        'partsRequestReturnBasket',
        'headerDynamicActions',
        'supplierOrders',
        'articleUpdateJobs',
        'fastTrackIssues',
        'serviceOrders',
        'serviceOrder',
        'serviceOrderJob',
        'serviceOrderJobs',
        'serviceOrderJobTotalAmount',
        'pendingServiceOrderReturn',
        'transferOrders',
      ],
      extraOptions: {
        requestSchema: HeaderDynamicActionsEventRequestSchema,
        responseSchema: HeaderDynamicActionsEventResponseSchema,
      },
    }),
  }),
});

export const {
  useGetWarehouseHeaderDynamicActionsQuery,
  usePutWarehouseHeaderDynamicActionsMutation,
} = metadaWarehouseHeaderDynamicActionsApi;
